import { AssignmentStatus, TrackingNumberStatus } from 'src/types/apiContract';
import { ReviewItemsFilterType } from 'src/types/shared';

import { CaptureId, CapturePiece } from '../../types';

type AccType = {
  items: CapturePiece[];
  isActiveInList: boolean;
  requireValidation: number;
  unassigned: number;
  processing: number;
  missingTracking: number;
  duplicate: number;
};

// SINGLE REDUCE FOR SEARCH, FILTER, COUNTING
export const prepareItems = (
  pieces: CapturePiece[],
  filter: ReviewItemsFilterType | null,
  activeId: CaptureId,
  search?: string,
) =>
  pieces.reduce<AccType>(
    (acc, item) => {
      const piece = item.piece;
      const recipient = piece?.recipient;

      // input search
      if (search) {
        const lowerSearch = search.toLowerCase();
        if (
          !recipient ||
          !(
            recipient.displayName?.toLowerCase().includes(lowerSearch) ||
            recipient.userName?.includes(lowerSearch) ||
            recipient.autoAssignId?.includes(lowerSearch)
          )
        ) {
          return acc;
        }
      }
      // if no filter add item to list
      if (!filter) acc.items.push(item);

      const {
        pieceAssignmentStatus,
        trackingNumberStatus,
        inProgressAutoAssign,
        inProgressTrackingNumberDetection,
        inProgressLockerAnnouncement,
      } = item.piece?.pieceSummary || {};
      // Processing item
      if (!piece || inProgressAutoAssign || inProgressTrackingNumberDetection || inProgressLockerAnnouncement) {
        acc.processing += 1;
        if (!piece) {
          return acc;
        }
      }

      // I HATE TYPESCRIPT
      // ALL FILTER OPTION COVER
      if (
        filter === ReviewItemsFilterType.ALL &&
        ([AssignmentStatus.RequireValidation, AssignmentStatus.Unassigned].includes(
          pieceAssignmentStatus as AssignmentStatus,
        ) ||
          [TrackingNumberStatus.Duplicate, TrackingNumberStatus.Missing].includes(
            trackingNumberStatus as TrackingNumberStatus,
          ))
      ) {
        acc.items.push(item);
      }

      // INDIVIDUAL OPTION FILTER COVER
      if (pieceAssignmentStatus === AssignmentStatus.RequireValidation) {
        acc.requireValidation += 1;
        if (filter === ReviewItemsFilterType.REQUIRE_VALIDATION) {
          acc.items.push(item);
          if (item.id === activeId) acc.isActiveInList = true;
        }
      }
      if (pieceAssignmentStatus === AssignmentStatus.Unassigned) {
        acc.unassigned += 1;
        if (filter === ReviewItemsFilterType.UNASSIGNED) {
          acc.items.push(item);
          if (item.id === activeId) acc.isActiveInList = true;
        }
      }
      if (trackingNumberStatus === TrackingNumberStatus.Duplicate) {
        acc.duplicate += 1;
        if (filter === ReviewItemsFilterType.DUPLICATE) {
          acc.items.push(item);
          if (item.id === activeId) acc.isActiveInList = true;
        }
      }
      if (trackingNumberStatus === TrackingNumberStatus.Missing) {
        acc.missingTracking += 1;
        if (filter === ReviewItemsFilterType.MISSING_TRACKING_NUMBER) {
          acc.items.push(item);
          if (item.id === activeId) acc.isActiveInList = true;
        }
      }
      return acc;
    },
    {
      items: [],
      isActiveInList: !filter || filter === ReviewItemsFilterType.ALL,
      requireValidation: 0,
      unassigned: 0,
      missingTracking: 0,
      duplicate: 0,
      processing: 0,
    },
  );
